import moment from 'moment';
import React from 'react'
import { useEffect } from 'react';
import { AuthState } from '../../../context/AuthProvider'
import {
    Br,
    Cut,
    Line,
    Printer,
    Text,
    Row,
    render,
} from "react-thermal-printer";

function AccountPrintPage(props) {
    
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'unset';
        }
    }, [])

    let PrintAccountDetail = () => {
        var accountPrintContainer =
            document.getElementById("accountPrintContainer").innerHTML;
        var accountPrintWindow = window.open("", "_blank");
        if (accountPrintWindow) {
            accountPrintWindow.document.open();
            accountPrintWindow.document.write(`<html>
            <head><title>Print it!</title> 
            <style>
        .printArea {
            font-size: 14px;
            font-family: Arial, sans-serif;
            color: black;
            width: 58mm;
            padding: 5px;
        }

        .header {
            text-align: center;
            margin-bottom: 5px;
        }

        .header-title {
            font-weight: bold;
            font-size: 14px;
        }

        .header-subtitle {
            font-size: 11px;
        }

        .divider {
            border-top: 1px dashed #000;
            margin: 5px 0;
        }

        .date-range {
            text-align: center;
            margin: 5px 0;
            font-weight: bold;
        }

        .summary-item {
            display: flex;
            justify-content: space-between;
            margin: 3px 0;
        }

        .label {
            font-weight: bold;
        }

        .value {
            font-weight: normal;
        }

        .footer {
            margin-top: 10px;
            text-align: center;
        }

        @media print {
            @page {
                margin: 0;
            }
        }
    </style>
            
            </head>
            <body>`)
            accountPrintWindow.document.write(accountPrintContainer);
            accountPrintWindow.document.write("</body></html>");
            accountPrintWindow.document.close();
            accountPrintWindow.focus();

            setTimeout(function () {
                accountPrintWindow.print();
                accountPrintWindow.close();
            }, 100);
        }
    }

    return (
        <>
            {/* <div
                className="text-center color-box-blue lh-33"
                id="accountPrintBtn"
                style={{ width: "13%", cursor: "pointer", backgroundColor: '#630C8D' }}
                onClick={() => PrintAccountDetail()}
            >
                Account print
            </div> */}
            <div className='w-1/8 px-2 self-center'>
              <button id="accountPrintBtn"
                className="bg-[#e54859] hover:bg-[#f03548] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
                type="button"
                onClick={() => PrintAccountDetail()}
              >
                Account print
              </button>
            </div>
            <div className='printContainer' id="accountPrintContainer" style={{ display: 'none' }}>
                <Content {...props} />
            </div>
        </>
    )
}

export default AccountPrintPage

let Content = (props) => {
    
    let { userDetail } = AuthState()
    console.log(userDetail)
    let { totalAmount, lotteryReport, fromDate, toDate } = props

    return (
        <>
            <Printer type="epson" characterSet="korea">
                <div className="printArea">
                    <div className="header">
                        <div className="header-title">Laxmi Lottery 3D</div>
                        <div className="header-subtitle">Amusement Only</div>
                    </div>
                    
                    <div className="divider"></div>
                    
                    <div className="date-range">
                        {moment().format('DD/MM/YYYY hh:mm A')}
                    </div>
                    
                    <div className="date-range">
                        {/* From: {fromDate.date}/{fromDate.month}/{fromDate.year}  */}
                        From: {moment(fromDate).format('DD/MM/YYYY hh:mm A')}
                        <br />
                        {/* To: {toDate.date}/{toDate.month}/{toDate.year} */}
                        To: {moment(toDate).format('DD/MM/YYYY hh:mm A')}
                    </div>
                    
                    <div className="divider"></div>
                    
                    {totalAmount.length && totalAmount.map((amount, index) => (
                        <div key={index}>
                            <div className="summary-item">
                                <span className="label">Total Play:</span>
                                <span className="value">{amount.play_amount}</span>
                            </div>
                            
                            <div className="summary-item">
                                <span className="label">Total Winning:</span>
                                <span className="value">{amount.win_amount}</span>
                            </div>
                            
                            {userDetail?.is_user !== true && (
                            <div className="summary-item">
                                <span className="label">Total Commission:</span>
                                <span className="value">{parseFloat(amount.commission_amount).toFixed(2)}</span>
                            </div>
                            )}
                            <div className="summary-item">
                                <span className="label">Operator:</span>
                                <span className="value">{amount.play_amount}</span>
                            </div>
                            
                            <div className="summary-item">
                                <span className="label">Total Net pt:</span>
                                <span className="value">{(amount.play_amount - amount.win_amount)}</span>
                            </div>
                        </div>
                    ))}
                    
                    <div className="divider"></div>
                    
                    <div className="footer">
                        Thank you for playing
                    </div>
                </div>
                <Cut />
            </Printer>
        </>
    )
}